module.exports = ".w{\n    min-width: 165px !important;\n}"